import { takeLatest, put, call } from 'redux-saga/effects';
import axios from 'axios';
import _get from 'lodash/get';
import { implementPromiseAction } from '@adobe/redux-saga-promise';

import api from '../../utils/apiConfig';
import UrlConfig from '../../utils/urlHelper';
import { FETCH_PAYMENT_OPTIONS } from './constants';
import { setPaymentOptions } from './action';
import {
  getCardType,
  verifyUPI,
  updateTransaction,
  fetchNBOptions,
  processTransaction,
  fetchPaymentResponse,
  addMoney,
} from './promiseAction';

interface Url {
  addMoney: Function;
  fetchPaymentOptions: Function;
  getCardType: Function;
  verifyUPI: Function;
  updateTransaction: Function;
  processTransaction: Function;
  fetchNBOptions: Function;
  fetchPaymentResponse: Function;
}

const urlHelper: Url = UrlConfig;

// worker Saga: will be fired on FETCH_VEHICLE_DATA actions
function* addMoneyToWallet(action: any) {
  try {
    const params = {
      amount: action.payload && action.payload.amount,
      entityType: 'WALLET',
      serviceProvider: 'PAYTM CUSTOM',
      useSsoToken: true,
      channel: 'WEB',
    };
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => api.post(urlHelper.addMoney(), params));
    });
  } catch (err) {}
}

function* fetchPaymentOptions(action: any) {
  try {
    const { query, params } = action.data;
    const paymentApi = axios.create();
    paymentApi.defaults.withCredentials = false;
    const response = yield paymentApi.post(urlHelper.fetchPaymentOptions(query), params);
    const responseData = _get(response, 'data.body', {});
    yield put(setPaymentOptions(responseData));
  } catch (e) {
    yield put(setPaymentOptions({}));
  }
}

function* getCardTypeFromPaytm(action: any) {
  try {
    const { mId, orderId, token, cardNumber } = action.payload;
    const query = `mid=${mId}&orderId=${orderId}`;
    const params = {
      head: {
        tokenType: 'TXN_TOKEN',
        token: token,
      },
      body: {
        bin: cardNumber,
      },
    };
    const paymentApi = axios.create();
    paymentApi.defaults.withCredentials = false;
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => paymentApi.post(urlHelper.getCardType(query), params));
    });
  } catch (err) {}
}

function* verifyUpIAddress(action: any) {
  try {
    const { mId, orderId, token, id } = action.payload;
    const query = `mid=${mId}&orderId=${orderId}`;
    const params = {
      head: {
        txnToken: token,
      },
      body: {
        vpa: id,
      },
    };
    const paymentApi = axios.create();
    paymentApi.defaults.withCredentials = false;
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => paymentApi.post(urlHelper.verifyUPI(query), params));
    });
  } catch (err) {}
}

function* updateTransactionDetails(action: any) {
  try {
    let config = {
      headers: {
        'X-APP-VERSION': 'web',
      },
    };
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => api.put(urlHelper.updateTransaction(), action.payload, config));
    });
  } catch (err) {}
}

function* processPaymentTransaction(action: any) {
  try {
    const { mId, orderId, token, ...rest } = action.payload;
    const query = `mid=${mId}&orderId=${orderId}`;
    const params = {
      head: {
        channelId: 'WAP',
        txnToken: token,
      },
      body: {
        ...rest,
        mid: mId,
        orderId,
      },
    };
    const paymentApi = axios.create();
    paymentApi.defaults.withCredentials = false;
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => paymentApi.post(urlHelper.processTransaction(query), params));
    });
  } catch (err) {}
}

function* fetchNBPaymentOptions(action: any) {
  try {
    const { mId, orderId, token } = action.payload;
    const query = `mid=${mId}&orderId=${orderId}`;
    const params = {
      head: {
        txnToken: token,
      },
      body: {
        type: 'MERCHANT',
      },
    };
    const paymentApi = axios.create();
    paymentApi.defaults.withCredentials = false;
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => paymentApi.post(urlHelper.fetchNBOptions(query), params));
    });
  } catch (err) {}
}

function* getPaymentResponse(action: any) {
  try {
    yield call(implementPromiseAction, action, function* () {
      return yield call(() => api.put(urlHelper.fetchPaymentResponse(action.payload)));
    });
  } catch (err) {}
}

/*
  Does not allow concurrent fetches of user. If "FETCH_VEHICLE_DATA" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
function* mySaga() {
  yield takeLatest(addMoney, addMoneyToWallet);
  yield takeLatest(FETCH_PAYMENT_OPTIONS, fetchPaymentOptions);
  yield takeLatest(processTransaction, processPaymentTransaction);
  yield takeLatest(getCardType, getCardTypeFromPaytm);
  yield takeLatest(verifyUPI, verifyUpIAddress);
  yield takeLatest(updateTransaction, updateTransactionDetails);
  yield takeLatest(fetchNBOptions, fetchNBPaymentOptions);
  yield takeLatest(fetchPaymentResponse, getPaymentResponse);
}

export default mySaga;
